import { DatabaseEntities } from "../../../common/models/database-entities.model";


export class GrainBoxCapacities extends DatabaseEntities<GrainBoxCapacities> {
    value: string;
}
